import React from 'react';
export function TopBar() {
  return <div className="bg-dorado text-negro text-center py-2.5 px-4 text-xs font-bold tracking-[0.08em] uppercase relative z-10" data-id="element-446">
      <span className="animate-pulse-bar inline-block" data-id="element-447">
        ⚡ Oferta por tiempo limitado — Solo quedan plazas disponibles
      </span>
    </div>;
}